<template>
  <div class="big-box">
    <navigation :crumbs="crumbs" @jumpColumn="jumpColumn" />
    <list v-if="type ==0 " :notice="noticeList" />
    <navigationList v-if="type ==1 " :notice="noticeList" @handlerCrumbs="handlerCrumbs" />
  </div>
</template>

<script>
import list from '@/components/list';
import navigation from '@/components/navigation';
import navigationList from '@/components/navigationList';
import { mapState } from 'vuex';
import { columnList } from '@/api/common';

export default {
  name: 'Index',
  components: {
    list,
    navigation,
    navigationList
  },
  data() {
    return {
      newsTitle: '民盟要闻',
      noticeTitle: '公告栏',
      noticeList: { },
      type: -1, // 0 没左侧栏目  1有左侧栏目
      crumbs: []
    };
  },

  computed: {
    ...mapState(['platFromArray', 'columnTree'])

  },
  watch: {
    '$route': {
      immediate: true,
      handler(to, from) {
        this.refresh(this.$route.query.name)
      }
    },
    platFromArray: {
      keep: true,
      handler: function(newPlatFromArray) {
        const nameArray = [];
        this.getColumnName(nameArray, newPlatFromArray);
      }
    }

  },
  created: function() {
    // this.columnList();
  },
  methods: {
    refresh(name) {
      if (name === '公示公告') {
        this.noticeList = {
          name: '公示公告',
          nickname: '公示公告',
          columnName: '公示公告',
          columnList: null,
          showType: 0
        }
        this.type = 0;
        this.crumbs = ['公示公告'];
        return
      }
      this.type = -1
      this.columnList();
    },
    getColumnName(nameArray, platFromArray) {
      var leng = platFromArray.length;
      if (leng === 1) {
        for (let i = 0; i < leng; i++) {
          // const element = array[i];
        }
      }
    },
    columnList() {
      const data = this.$route.query.name;
      columnList(data).then(res => {
        this.noticeList = res.data
        if (this.noticeList.columnList == null) {
          this.type = 0
        } else {
          this.type = 1
        }
        this.getCrumbs(data, res.data);
      })
    },
    // 兼容三级
    getCrumbs(columnName, columnObj, crtColumn) {
      const topColumnName = columnObj.columnName;
      const crumbs = [];
      // 顶级
      if (columnName === topColumnName) {
        this.crumbs = [columnName];
        return;
      }
      // 二级三级判断
      const columnList = columnObj.columnList;
      const currentColumn = crtColumn || this.getCurrentColumn(columnName, columnList);
      if (currentColumn.parentName && currentColumn.parentName !== topColumnName) {
        crumbs.push(topColumnName)
        crumbs.push(currentColumn.parentName)
        crumbs.push(columnName)
      } else {
        crumbs.push(topColumnName)
        crumbs.push(columnName);
      }
      this.crumbs = crumbs;
    },
    getCurrentColumn(columnName, columnList) {
      let crtColumn = {};
      for (let index = 0; index < columnList.length; index++) {
        const column = columnList[index];
        if (column.columnList) {
          crtColumn = this.getCurrentColumn(columnName, column.columnList)
        } else if (columnName === column.name) {
          return column;
        }
      }
      return crtColumn;
    },
    handlerCrumbs({ columnName, column }) {
      this.getCrumbs(columnName, this.noticeList, column);
    },
    jumpColumn(colubName) {
      this.$router.push({
        path: '/subPage',
        query: {
          name: colubName
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.big-box {
  width: 100%;
  min-height: 850px;
  .main {
  }
}
</style>
